import React from 'react';
import { clsx } from 'clsx';
import { useTheme } from 'src/provider/ThemeProvider';
import { ChangeKnowledgeBase } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/ChangeKnowledgeBase/ChangeKnowledgeBase';

export const KnowledgeBases = () => {
  return (
    <div className="flex flex-col items-start gap-3.5 w-full">
      <ChangeKnowledgeBase />
    </div>
  );
};
